"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageNativeName = void 0;
const enums_1 = require("@finbackoffice/enums");
const Languages = new Map();
Languages.set(enums_1.Language.en, { nativeName: "English" });
Languages.set(enums_1.Language.ru, { nativeName: "Русский" });
Languages.set(enums_1.Language.ko, { nativeName: "한국어" });
Languages.set(enums_1.Language.tr, { nativeName: "Türkçe" });
Languages.set(enums_1.Language.ja, { nativeName: "日本語" });
Languages.set(enums_1.Language.de, { nativeName: "Deutsch" });
Languages.set(enums_1.Language.es, { nativeName: "Español" });
Languages.set(enums_1.Language.pt, { nativeName: "Português" });
Languages.set(enums_1.Language.ro, { nativeName: "Romanian" });
Languages.set(enums_1.Language.sw, { nativeName: "Swahili" });
const getLanguageNativeName = (key) => {
    if (Languages.has(key)) {
        return Languages.get(key).nativeName;
    }
    return "N/A";
};
exports.getLanguageNativeName = getLanguageNativeName;
//# sourceMappingURL=languages.js.map